import React, { FC } from 'react';
import classnames from 'classnames';
import { Link, graphql } from 'gatsby';

import { IPainHomeBannerComponentProps } from './model';
import './PainHomeBannerSub.scss';
import DangerouslySetInnerHtml from '../common/DangerouslySetInnerHtml';
import UniversalImage from '../common/UniversalImage';

const PainHomeBannerSub: FC<IPainHomeBannerComponentProps> = ({
  painHomeBannerTitleRteSub,
  painHomeBannerBackgroundImageSub,
  painHomeBannerTextSub,
  painHomeBannerLogoTitleSub,
  painHomeBannerLogoTitleAltSub,
  painHomeBannerHeroImageSub,
  painHomeBannerThemeSub,
  painHomeBannerDisclaimerSub,
  painHomeBannerLinkSub,
  painHomeBannerDisclaimer,
  painHomeBannerTheme,
}) => {
  return (
    <div
      className={classnames(
        'pain-home-banner-sub',
        `pain-home-banner-sub-${painHomeBannerThemeSub}`,
        { [`pain-home-banner-sub--${painHomeBannerTheme}`]: painHomeBannerTheme }
      )}
      style={{
        zIndex: 1,
        backgroundImage: painHomeBannerBackgroundImageSub?.fallbackUrl
          ? `url(${painHomeBannerBackgroundImageSub.fallbackUrl})`
          : undefined,
      }}
    >
      <div className="container-fluid">
        <div className="pain-home-banner-sub__content">
          <div className="pain-home-banner-sub__top-content">
            {painHomeBannerLogoTitleSub ? (
              <UniversalImage
                imageAlt={painHomeBannerLogoTitleAltSub}
                img={painHomeBannerLogoTitleSub}
                wrapperClassName="pain-home-banner-sub__logo-title"
              />
            ) : null}
            <DangerouslySetInnerHtml
              className="pain-home-banner-sub__heading"
              element="div"
              html={painHomeBannerTitleRteSub}
            />
          </div>
          <div className="pain-home-banner-sub__bottom-content">
            <Link
              className="pain-home-banner-sub__link"
              to={painHomeBannerLinkSub[0].properties.link[0].url}
            >
              {painHomeBannerLinkSub[0].properties.text}
            </Link>
            <div className="pain-home-banner-sub__text">
              <DangerouslySetInnerHtml html={painHomeBannerTextSub} />
            </div>
          </div>
        </div>
        <UniversalImage
          wrapperClassName="pain-home-banner-sub__hero-image"
          objectFitData={{ objectFit: 'cover' }}
          img={painHomeBannerHeroImageSub}
        />
        <DangerouslySetInnerHtml
          className="pain-home-banner-sub__disclaimer"
          html={painHomeBannerDisclaimer}
        />
      </div>
      {painHomeBannerDisclaimerSub ? (
        <div className="pain-home-banner-sub__disclaimer-container">
          <DangerouslySetInnerHtml html={painHomeBannerDisclaimerSub} />
        </div>
      ) : null}
    </div>
  );
};

export const query = graphql`
  fragment FragmentPainHomeBannerSub on IPainHomeBannerSub {
    painHomeBannerTitleRteSub
    painHomeBannerBackgroundImageSub {
      fallbackUrl
      gatsbyImage {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
    painHomeBannerHeroImageSub {
      fallbackUrl
      gatsbyImage {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
    painHomeBannerLogoTitleSub {
      fallbackUrl
      url
      gatsbyImage {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      svg {
        content
      }
    }
    painHomeBannerLogoTitleAltSub
    painHomeBannerTextSub
    painHomeBannerThemeSub
    painHomeBannerDisclaimerSub
    painHomeBannerLinkSub {
      properties {
        ...FragmentNFButton
      }
    }
    painHomeBannerDisclaimer
    painHomeBannerTheme
  }
`;

export default PainHomeBannerSub;
